import Page from '@/found/components/table_page';
import Form from '../form/index';

export default {
  name: 'material_usage_request',
  extends: Page,
  data() {
    return {
      params: {},
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus } = row;
      if (approveStatus && code === 'edit' && (approveStatus === '1' || approveStatus === '2')) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      const { code } = val;
      console.log('code', code);
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
    },
  },
};
